/* Types */
import styled from 'styled-components';
import { convertPropsToCssRules } from '../../../helpers/styled';

export interface WrapperPropsToPaste {
  backgroundColor?: string;
  margin?: string;
  padding?: string;
}
export type WrapperProps = WrapperPropsToPaste;

export const Wrapper = styled.div.attrs({ className: 'icb' as string })<WrapperProps>`
  ${convertPropsToCssRules<WrapperPropsToPaste>(['margin'])};
`;
